export enum UserRoleEnum {
    ADMIN = 'admin',
}